import React, {Fragment, Component} from 'react';
import classNames from 'classnames';

export default class AvailableSDS extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tableIsCutOff: false
        };

        this.tableRef1 = React.createRef();
        this.tableRef2 = React.createRef();

        this.checkIfTablesAreCutOff = this.checkIfTablesAreCutOff.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.checkIfTablesAreCutOff, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkIfTablesAreCutOff, false);
    }

    componentDidUpdate(prevProps) {
        if (this.props.shouldResultsRender !== prevProps.shouldResultsRender) {
            this.checkIfTablesAreCutOff();
        }
    }

    checkIfTablesAreCutOff() {
        const checkTable = (tableRef) => {
            if (tableRef) {
                const
                    tableWidth = tableRef.scrollWidth,
                    leftSpace = tableRef.getBoundingClientRect().left,
                    minimalSpaceAround = leftSpace * 2,
                    availableSpaceWidth = document.body.clientWidth - minimalSpaceAround,
                    isTableCutOff = Math.floor(tableWidth) > Math.floor(availableSpaceWidth);

                this.setState({tableIsCutOff: isTableCutOff});
            }
        };

        if (this.props.shouldResultsRender) {
            checkTable(this.tableRef1.current);
            checkTable(this.tableRef2.current);
        }
    }

    renderTable(documents, firstColumnName, ref) {
        const tableClasses = classNames('main-product__table', {'fat': this.state.tableIsCutOff});
       
        return (
            <div className="sds-widget__item">
                <table className={tableClasses} ref={ref}>
                    <thead>
                    <tr>
                        <th>{firstColumnName}</th>
                        <th>File name</th>
                        <th>File</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.renderRows(documents)}
                    {this.renderDowloadAll(documents)}
                    </tbody>
                </table>
            </div>
        )

    }

    renderDowloadAll(documents){
        const {fetchAllPDF} = this.props;

        if(documents && documents.length > 1){
            return (
                <tr>
                <td>Download all</td>
                <td></td>
                <td>
                    <button type="button"
                            onClick={(e) => fetchAllPDF(e, documents)}
                            className="sds-widget__download-btn"
                    >
                        Download all files
                    </button>
                </td>
            </tr>
            );
        }
    }

    renderRows(documents) {
        const {
            fetchPDF
        } = this.props;

        return documents.map(document => {
            return (
                <tr key={document.Name}>
                    <td>{document.Name}</td>
                    <td>{document.FileName}</td>
                    <td>
                        <button type="button"
                                onClick={(e) => fetchPDF(e, document.Link, document.FileName)}
                                className="sds-widget__download-btn"
                        >
                            Download file
                        </button>
                    </td>
                </tr>
            )
        });
    }

    render() {
        const {
            shouldResultsRender,
            errorDocuments,
            errorDownloadingPDF,
            documentsList
        } = this.props;

        const
            mainDocument = documentsList.MainDocument,
            relatedDocuments = documentsList.RelatedDocuments;

        if (shouldResultsRender) {
            if (errorDocuments) {
                return (
                    <p className="sds-widget__error-message">Could not find available documents</p>
                );
            }
            return (
                <Fragment>
                    <div className="sds-widget__item sds-widget__item--space-top">
                        <h3>Available SDS</h3>
                    </div>

                    {mainDocument &&
                    this.renderTable(documentsList.MainDocument, 'Product', this.tableRef1)
                    }
                    {relatedDocuments && relatedDocuments.length > 0 &&
                    this.renderTable(relatedDocuments, 'Related Products', this.tableRef2)
                    }

                    {errorDownloadingPDF &&
                    <Fragment>
                        <p className="sds-widget__error-message">
                            Could not download the document
                        </p>
                    </Fragment>
                    }
                </Fragment>
            )
        } else {
            return null;
        }
    }
}